import React, { Component } from "react";
import _ from "lodash";

export interface GameSelectItem {
    value: string | number;
    label: string;
    appendex?: any;
}

export interface GameSelectProps {
    field?: any;
    form?: any;
    selectedGames?: (string | number)[];
    givenid?: string;
    completeList?: { label: any; value: any; appendex?: any }[];
    bundlesList?: { label: any; value: any; games: any[] }[];
    exclusive?: boolean;
    disabled?: boolean;
}

let checker = (arr, target) => target.every(v => arr.map(String).includes(String(v)));

export interface GameSelectState {
    searchText: string;
}

function escapeRegExp(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

const formatSearchText = (text, value) => {
    // Split on higlight term and include term into parts, ignore case
    let parts = text.split(new RegExp(`(${escapeRegExp(value)})`, "gi"));
    return (
        <span>
            {parts.map((part, i) => {
                if (part.toUpperCase() == value.toUpperCase())
                    return (
                        <span className="highlighted" key={i}>
                            {part}
                        </span>
                    );
                else return part;
            })}
        </span>
    );
};

export default class BaseGameSelect extends Component<
    GameSelectProps,
    GameSelectState
> {
    searchBox: React.RefObject<HTMLInputElement>;

    constructor(props: GameSelectProps) {
        super(props);
        this.searchBox = React.createRef();
        this.state = {
            searchText: ""
        };
    }

    getBundleGames = bundle => bundle.games
        .filter(game => this.props.completeList.some(item => item.value == game.id))
        .map(game => game.id);

    getSelectedBundleIds = games => this.props.bundlesList
        .filter(bundle => {
            const bundleGames = this.getBundleGames(bundle);
            return bundleGames.length > 0 && checker(games, bundleGames);
        })
        .map(bundle => bundle.value);

    setSelection = games => {
        this.props.form.setValues({
            ...this.props.form.values,
            [this.props.field.name]: games,
            game_bundles: this.getSelectedBundleIds(games)
        });
    };

    syncSelectedBundles = () => {
        if (this.props.disabled || !this.props.bundlesList.length || !this.props.completeList.length) return;

        // Older configurations stored only games; persist the bundles shown as selected.
        const selectedBundles = this.getSelectedBundleIds(this.props.field.value);
        if (!_.isEqual(this.props.form.values.game_bundles || [], selectedBundles)) {
            this.setSelection(this.props.field.value);
        }
    };

    componentDidMount() {
        this.syncSelectedBundles();
    }

    componentDidUpdate() {
        this.syncSelectedBundles();
    }

    onChangeHandler = selectedItem => {
        if (this.props.disabled) return;

        let newValue = [...this.props.field.value];
        if (newValue.includes(selectedItem.value)) {
            const index = newValue.indexOf(selectedItem.value);
            if (index > -1) {
                newValue.splice(index, 1);
            }
        } else {
            newValue.push(selectedItem.value);
        }

        this.setSelection(newValue);
    };

    onSelectBundle = selectedBundle => {
        if (this.props.disabled) return;

        const bundleGames = this.getBundleGames(selectedBundle);

        let newValue = [];
        if (checker(this.props.field.value, bundleGames)) {
            newValue = this.props.field.value.filter(
                item => !bundleGames.map(String).includes(String(item))
            );
        } else {
            newValue = [
                ...new Set([...this.props.field.value, ...bundleGames])
            ];
        }

        this.setSelection(newValue);
    };

    setSearch = e => {
        this.setState({
            searchText: e.target.value
        });
    };

    cleanSearch = () => {
        this.setState({
            searchText: ""
        });
        this.searchBox.current.value = "";
    };

    render() {
        const items = _.orderBy(
            _.uniqBy(
                this.props.completeList,
                item => `${item.value}`
            ),
            ["label"],
            ["asc"]
        ).filter(game => {
            if (
                this.props.selectedGames.includes(game.value) &&
                !this.props.field.value.includes(game.value)
            ) {
                return false;
            }
            return true;
        });

        const fieldName = this.props.field.name;
        const errors = this.props.form.errors[fieldName];

        const errorMessageEl = errors && (
            <div className="input-error">
                <span className="input-error-message">{errors}</span>
            </div>
        );

        let bundles = this.props.bundlesList.filter(bundle => {
            let filteredGames = bundle.games.filter(game => {
                const index = this.props.completeList.findIndex(
                    item => item.value == game.id
                );
                if (index > -1) {
                    return true;
                }
                return false;
            });

            let found = true;
            filteredGames.map(game => {
                if (found == true) {
                    const index = items.findIndex(
                        item => item.value == game.id
                    );
                    if (index == -1) {
                        found = false;
                    }
                }
            });
            return found;
        });

        return (
            <div
                id={this.props.givenid + " Bullets-Select"}
                className={`bullets-select ${
                    this.props.disabled ? "disabled" : ""
                }`}
            >
                <div className="input-group">
                    {bundles && bundles.length == 0 && (
                        <p>No items available to choose from.</p>
                    )}
                    {bundles &&
                        bundles.map(item => {
                            return (
                                <div
                                    key={item.value}
                                    onClick={() => this.onSelectBundle(item)}
                                    className={`bullet ${
                                        checker(
                                            this.props.field.value,
                                            this.getBundleGames(item)
                                        ) && this.getBundleGames(item).length > 0
                                            ? "selected"
                                            : ""
                                    }`}
                                >
                                    {item.label}
                                </div>
                            );
                        })}
                </div>
                <div className="input-group">
                    <div className="label-tooltip">
                        <label className="label">Game Instances</label>
                    </div>
                    <div
                        className={`bullet-search ${
                            this.state.searchText.length ? "searching" : ""
                        }`}
                    >
                        <input
                            placeholder="Search"
                            type="text"
                            ref={this.searchBox}
                            onChange={this.setSearch}
                        />
                        <button className="clean" onClick={this.cleanSearch}>
                            <i className="icon-times-solid"></i>
                        </button>
                    </div>

                    {!this.props.field.value &&
                        this.props.field.value.length == 0 &&
                        items.length == 0 && (
                            <p>No items available to choose from.</p>
                        )}
                    {items.map(item => {
                        const label =
                            this.state.searchText !== null &&
                            this.state.searchText.length > 2
                                ? formatSearchText(
                                      item.label,
                                      this.state.searchText
                                  )
                                : item.label;
                        return (
                            <div
                                key={item.value}
                                onClick={() => this.onChangeHandler(item)}
                                className={`bullet ${
                                    this.props.field.value.includes(item.value)
                                        ? "selected"
                                        : ""
                                } ${item.appendex ? item.appendex : ""}`}
                            >
                                {label}
                            </div>
                        );
                    })}
                </div>
                {errorMessageEl}
            </div>
        );
    }
}
